<template>
  <div
    v-if="hasImageSource"
    class="sp__hero-banner"
  >
    <figure class="sp__hero-banner__figure">
      <picture class="sp__hero-banner__image">
        <template
          v-for="(source, index) in customProps.imageSources"
          :key="index"
        >
          <source
            :media="'(' + source.media + ')'"
            :srcset="source.source"
          >
        </template>
        <img
          class="sp__hero-banner__image"
          :src="customProps.fallback"
          alt=""
        >
      </picture>
    </figure>
  </div>
</template>

<script src="./hero-banner.mjs"></script>
